import React from 'react'

import { useInView } from 'react-cool-inview'

import { ArrowRight, Icon } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { arrayOf, shape, string } from 'prop-types'

import useTracker from 'Pods/Shared/Hooks/useTracker'
import i18n from 'Pods/Shared/I18nHome'
import ImageMosaic from 'Pods/Shared/ImageMosaic/ImageMosaic'

function CollectionCard({ collection, sectionId, sectionTitle, locale = 'en' }) {
  const { trackEvent } = useTracker()

  const { observe } = useInView({
    threshold: 0.5,
    onEnter: ({ unobserve }) => {
      unobserve()
      trackEvent('curated_collection_impression', {
        collection_name: collection.title,
        collection_id: collection.id,
        section_name: sectionTitle,
        section_id: sectionId,
      })
    },
  })

  const handleCardClick = () => {
    trackEvent('curated_collection_click', {
      collection_name: collection.title,
      collection_id: collection.id,
      section_name: sectionTitle,
      section_id: sectionId,
      element_url: collection.href,
    })
  }

  return (
    <article ref={observe} className="collection-hub-card" onClick={handleCardClick}>
      <div className="collection-hub-card__image-container">
        {collection.imageUrl ? (
          <img
            src={collection.imageUrl}
            alt={collection.title}
            className="collection-hub-card__image"
            loading="lazy"
          />
        ) : (
          <ImageMosaic images={collection.previewImages} lazy />
        )}
      </div>
      <div className="collection-hub-card__content">
        <h3 className="collection-hub-card__title cgt-heading-100">{collection.title}</h3>
        <p className="collection-hub-card__description cgt-body-base">{collection.description}</p>
      </div>
      <a
        href={collection.href}
        className="collection-hub-card__link"
        aria-label={
          i18n.t(
            'curatedCollections.goToCollectionAriaLabel', { title: collection.title, ns: 'new-home', lng: locale }
          )
        }
      >
        <span>{i18n.t('curatedCollections.goToCollection', { ns: 'new-home', lng: locale })}</span>
        <Icon svgComponent={ArrowRight} size="small" />
      </a>
    </article>
  )
}

CollectionCard.propTypes = {
  collection: shape({
    id: string,
    title: string,
    description: string,
    imageUrl: string,
    href: string,
    previewImages: arrayOf(
      shape({
        id: string.isRequired,
        url: string.isRequired,
        alt: string.isRequired,
      })
    ),
  }).isRequired,
  locale: string,
  sectionId: string.isRequired,
  sectionTitle: string.isRequired,
}

export default CollectionCard
